var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"checkbox-container mr-2"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.props.checked},on:{"change":function($event){return _vm.listeners.change($event)}}}),_c('span',{staticClass:"checkmark"})])}
var staticRenderFns = []

export { render, staticRenderFns }